export default __webpack_public_path__ + "static/media/livro8.88ef3216.png";